function Totals () {
  this.simple = {
    distance: 0,
    duration: 0,
    price: 0
  };
  this.to = {
    distance: 0,
    duration: 0,
    price: 0
  };
  this.back = {
    distance: 0,
    duration: 0,
    price: 0
  };
  this.total = {
    distance: 0,
    duration: 0,
    price: 0
  };
}

export default Totals
